exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-nav-wrapper[data-v-5851150c]{margin-top:-5rem;border-bottom:1px solid #e0e0e0;background:#fff;pointer-events:none;transition:opacity .2s ease;opacity:0;z-index:100;position:relative}.top-nav-wrapper.is-affixed[data-v-5851150c]{opacity:1;pointer-events:all}.top-nav-wrapper ul[data-v-5851150c]{position:absolute;left:0;right:0;top:0}ul.top-nav[data-v-5851150c]:after{content:\"\";position:absolute;bottom:0;height:1px;background:var(--black-light-2);left:-1000px;right:-1000px}", ""]);

// exports
